export default __webpack_public_path__ + "static/media/survey.5c2a1fc0.svg";